import { F0Alert } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

type Props = {
  assigneesTotalCount?: number
}

export const DiscardWarningAlert = ({ assigneesTotalCount }: Props) => {
  if (assigneesTotalCount !== undefined && assigneesTotalCount <= 1) {
    return null
  }

  return (
    <F0Alert
      variant="warning"
      title={i18n.t('tasks.discard_warning_title')}
      description={i18n.t('tasks.discard_warning')}
    />
  )
}
